"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionArea_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var PermissionRestrictionPoint_1 = require("./PermissionRestrictionPoint");
var PermissionArea_Factory = /** @class */ (function () {
    function PermissionArea_Factory() {
    }
    PermissionArea_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Description: model.Description,
            PermissionAreaId: model.PermissionAreaId,
            PermissionRestrictionPoints: model.PermissionRestrictionPoints && model.PermissionRestrictionPoints.map(function (i) { return PermissionRestrictionPoint_1.PermissionRestrictionPoint_Factory.CreateIncoming(i); }),
            SortPosition: model.SortPosition,
        };
        return result;
    };
    PermissionArea_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Description: model.Description,
            PermissionAreaId: model.PermissionAreaId,
            PermissionRestrictionPoints: model.PermissionRestrictionPoints && model.PermissionRestrictionPoints.map(function (i) { return PermissionRestrictionPoint_1.PermissionRestrictionPoint_Factory.CreateOutgoing(i); }),
            SortPosition: model.SortPosition,
        };
        return result;
    };
    return PermissionArea_Factory;
}());
exports.PermissionArea_Factory = PermissionArea_Factory;
